import { Link } from 'expo-router';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { Spacing } from '@/constants/theme';
import { useTheme } from '@/hooks/use-theme';
import type { ListingLink } from '@/lib/listing-links';

/** A wrapping row of pill links to listing pages (ListingLink — anchor text is each page's own title). */
export function ListingLinkPills({ links }: { links: ListingLink[] }) {
  const theme = useTheme();

  return (
    <View style={styles.links}>
      {links.map((link) => (
        <Link key={link.key} href={link.href} asChild>
          <Pressable accessibilityRole="link">
            {({ pressed }) => (
              // Pill styling on an inner View: <Link asChild> drops a
              // Pressable's function-style `style` on web.
              <View
                style={[
                  styles.pill,
                  { backgroundColor: theme.card, borderColor: theme.border },
                  pressed && { opacity: 0.85 },
                ]}>
                <Text style={[styles.pillText, { color: theme.primary }]}>{link.label}</Text>
              </View>
            )}
          </Pressable>
        </Link>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  links: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: Spacing.two,
  },
  pill: {
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 999,
    borderWidth: 1,
  },
  pillText: {
    fontSize: 14,
    fontWeight: '600',
  },
});
